var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.826996,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.826996,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1008 16H22.577V0H12.1008V16Z",
    fill: "#DE233C"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_1_2528",
    maskUnits: "userSpaceOnUse",
    x: 1.67223,
    y: 1.13333,
    width: 5,
    height: 5,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.67223,
    y: 1.13333,
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76747 2.13333H3.71985V3.2H2.67223V4.26667H3.71985V5.33333H4.76747V4.26667H5.81509V3.2H4.76747V2.13333Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76747 2.13333H3.71985V3.2H2.67223V4.26667H3.71985V5.33333H4.76747V4.26667H5.81509V3.2H4.76747V2.13333Z",
    fill: "#CCCCCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71985 2.13333V1.46667H3.05319V2.13333H3.71985ZM4.76747 2.13333H5.43414V1.46667H4.76747V2.13333ZM3.71985 3.2V3.86667H4.38652V3.2H3.71985ZM2.67223 3.2V2.53333H2.00557V3.2H2.67223ZM2.67223 4.26667H2.00557V4.93333H2.67223V4.26667ZM3.71985 4.26667H4.38652V3.6H3.71985V4.26667ZM3.71985 5.33333H3.05319V6H3.71985V5.33333ZM4.76747 5.33333V6H5.43414V5.33333H4.76747ZM4.76747 4.26667V3.6H4.10081V4.26667H4.76747ZM5.81509 4.26667V4.93333H6.48176V4.26667H5.81509ZM5.81509 3.2H6.48176V2.53333H5.81509V3.2ZM4.76747 3.2H4.10081V3.86667H4.76747V3.2ZM3.71985 2.8H4.76747V1.46667H3.71985V2.8ZM4.38652 3.2V2.13333H3.05319V3.2H4.38652ZM2.67223 3.86667H3.71985V2.53333H2.67223V3.86667ZM3.3389 4.26667V3.2H2.00557V4.26667H3.3389ZM3.71985 3.6H2.67223V4.93333H3.71985V3.6ZM4.38652 5.33333V4.26667H3.05319V5.33333H4.38652ZM4.76747 4.66667H3.71985V6H4.76747V4.66667ZM4.10081 4.26667V5.33333H5.43414V4.26667H4.10081ZM5.81509 3.6H4.76747V4.93333H5.81509V3.6ZM5.14842 3.2V4.26667H6.48176V3.2H5.14842ZM4.76747 3.86667H5.81509V2.53333H4.76747V3.86667ZM4.10081 2.13333V3.2H5.43414V2.13333H4.10081Z",
    fill: "#7B716A",
    fillOpacity: 0.66,
    mask: "url(#path-4-outside-1_1_2528)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24367 4.26667C4.53296 4.26667 4.76748 4.02789 4.76748 3.73333C4.76748 3.43878 4.53296 3.2 4.24367 3.2C3.95437 3.2 3.71986 3.43878 3.71986 3.73333C3.71986 4.02789 3.95437 4.26667 4.24367 4.26667Z",
    fill: "#7B716A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/mt.e7c4c7f39af93d32dd580be202fdacf4.svg";
export { ForwardRef as ReactComponent };